/*
 * Whiff Culture — animated wordmark reveal for the header logo.
 * Letters fade in one by one. Loops continuously for as long as the page
 * is open.
 *
 * Safe by construction:
 * - If this script fails to run at all, the plain shop name text rendered
 *   by the snippet stays visible (no FOUC / no broken layout).
 * - Respects prefers-reduced-motion: shows the static, fully-revealed name
 *   with no animation and does not loop.
 * - Only animates transform/opacity (no layout writes).
 */
(function () {
  var slot = document.getElementById('premiumLogo');
  if (!slot) return;

  var full = slot.querySelector('.wc-full');
  if (!full) return;

  var text = full.getAttribute('data-text') || full.textContent.trim();
  if (!text) return;

  full.innerHTML = '';
  text.split('').forEach(function (ch, i) {
    var span = document.createElement('span');
    span.className = 'wc-letter';
    span.style.setProperty('--i', i);
    span.textContent = ch === ' ' ? ' ' : ch;
    full.appendChild(span);
  });
  var letters = full.querySelectorAll('.wc-letter');

  // timeline: last letter lands ~984ms in
  var REVEAL_MS = 1000; // time until all letters have fully faded in
  var HOLD_MS = 1000; // extra time the crisp wordmark sits alone before looping
  var FADE_MS = 300; // quick fade-out before the next cycle
  var loopTimer = null;

  function reducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function clearLoop() {
    if (loopTimer) {
      clearTimeout(loopTimer);
      loopTimer = null;
    }
  }

  function play() {
    clearLoop();
    slot.classList.remove('wc-play', 'wc-exit');
    letters.forEach(function (el) {
      el.style.animation = 'none';
      el.style.opacity = '';
      el.style.transform = '';
    });
    void slot.offsetWidth; // force reflow so the animation can restart
    letters.forEach(function (el) {
      el.style.animation = '';
    });

    if (reducedMotion()) {
      letters.forEach(function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    slot.classList.add('wc-play');

    loopTimer = setTimeout(function () {
      slot.classList.add('wc-exit');
      loopTimer = setTimeout(function () {
        play();
      }, FADE_MS);
    }, REVEAL_MS + HOLD_MS);
  }

  play();

  // resume the loop if a throttled background tab paused the timers
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !loopTimer && !reducedMotion()) {
      play();
    }
  });
})();
